import { ReactNode } from 'react';
import { RenderCellParam } from './type';

const colW = [40, 52, 65, 82, 95, 102, 120, 160, 200, 230, 250, 300];

const isUndefined = (value: unknown): value is undefined =>
  typeof value === 'undefined';

const nullToEmpty = (value: unknown): string =>
  [undefined, null].some((obj) => obj === value) ? '' : String(value);

const generateRandomString = (length = 12, randomString = ''): string => {
  let str = randomString;
  str += Math.random().toString(20).substr(2, length);
  return str.length >= length
    ? str.slice(0, length)
    : generateRandomString(length, str);
};

let timer: NodeJS.Timeout;
export const timerDebounce = (func: () => void, delay = 1000): void => {
  if (timer) {
    clearInterval(timer);
  }
  timer = setTimeout(func, delay);
};

const defaultTdStr = (params: RenderCellParam<unknown>): ReactNode => {
  const {
    column: { trans },
    value,
  } = params;
  return trans ? trans(value) : nullToEmpty(value);
};

export { isUndefined, nullToEmpty, defaultTdStr, generateRandomString };
export default colW;
